import { useDispatch } from "react-redux";
import styles from "./Projetosparticulares.module.css"
import { newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { LuNotebookPen } from "react-icons/lu";


const ProjetosParticulares = () => {
    const dispatch = useDispatch();

    const onClickAbrirConsultaPrevia = () => {
        const consultaprevia = {
            Nome: "Consulta prévia",
            Aba: 17
        }
        
        dispatch(newTab(consultaprevia));
        
        dispatch(setTabFromNewIndex(consultaprevia.Aba));

    }

    const onClickAbrirAnaliseProjeto = () => {
        const analiseprojeto = {
            Nome: "Análise projeto",
            Aba: 19
        }
        
        dispatch(newTab(analiseprojeto));
        
        dispatch(setTabFromNewIndex(analiseprojeto.Aba));

    }

    return (
        <div className={styles.dashboard_main}>
        <section className={styles.dashboardSection}>
            <button className={styles.dashboardButton} onClick={onClickAbrirConsultaPrevia}>
                <MdOutlineAssignmentTurnedIn size={32}/>
                Consulta prévia
            </button>
            <button className={styles.dashboardButton} onClick={onClickAbrirAnaliseProjeto}>
                <LuNotebookPen size={32}/>
                Análise projeto
            </button>
        </section>
        <p className={styles.merchanUseall}>Desenvolvido por <a className={styles.linkUseall} href="http://www.useall.com.br" target={"_blank"}>Useall Software</a></p>
    </div>
    )
}

export { ProjetosParticulares };